<template>
  <div class="spinner-wrapper">
    <div class="spinner"></div>
    <!-- <div style="text-align:center;font-size:12px;">正在登录中</div> -->
  </div>
</template>

<script>
import util from "../../../common/util";
import config from "../../../common/config";
import { UserManager } from "oidc-client";
export default {
  mounted() {
    new UserManager(config).signinRedirect();
  }
};
</script>


<style scoped>
body{
  overflow: hidden;
}
.spinner-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
}
.spinner {
  width: 60px;
  height: 60px;
  background-color: #67cf22;
  margin: 200px auto;
  -webkit-animation: rotateplane 1.2s infinite ease-in-out;
  animation: rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }

  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }

  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}

@keyframes rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }

  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }

  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/public/login.vue